import React from 'react';
import Svg from './Svg';

export default function Video(props) {
  return (
    <Svg
      {...props}
      d="M950,865.4l-900,0l0,-730.8l900,0l0,730.8Zm-843.3,-55.8l787.5,0l0,-619.2l-787.5,0l0,619.2Zm280.8,-151.2l0,-316.8l315.9,158.4l-315.9,158.4Zm56.7,-225l0,133.2l133.2,-66.6l-133.2,-66.6Z"
    />
  );
}
